import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { CheckAvailability } from '@thd-olt-component-react/check-availability';
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { shipping } from '../helpers/model';
import utils from '../helpers/utils';
import DeliveryContent from './DeliveryContent';
import './delivery-options.style.scss';
import { track } from '../analytics';
import { dataModel } from './dataModel';

const DeliveryOptions = (props) => {
  const {
    itemId,
    onZipCodeChange,
    quantity,
    children,
    visible
  } = props;
  const { storeId, storeZip } = useStore();

  const { data } = useDataModel('clientOnlyProduct', {
    variables: { itemId, storeId }, ssr: false
  });
  const { value } = data?.product?.pricing || {};
  const detaZip = utils.getDETAZip();
  const deliveryZip = utils.getDeliveryZip();
  const zipCode = deliveryZip || detaZip || storeZip;

  const [getShipping, shippingResponse] = useDataModel('shipping', {
    variables: {
      itemId,
      storeId,
      zipCode,
      quantity,
      price: parseInt((value * quantity).toFixed(2), 10)
    }
  }, true);
  useEffect(() => {
    if (value && storeId !== '8119') {
      getShipping();
    }
  }, [value, quantity, storeId, zipCode]);

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    track('click', {
      origin: 'delivery-options',
      eventName: 'shipping options',
      primaryCategory: 'tooltip'
    });
  };

  if ((shippingResponse.error && !shippingResponse.data) || !shippingResponse.data || shippingResponse.loading) {
    return null;
  }

  const shippingModel = shipping(shippingResponse.data.shipping);

  return (
    <div className="delivery-options">
      <Tooltip
        channel="desktop"
        closeButton
        visible={visible}
        content={(
          <DeliveryContent
            itemId={itemId}
            quantity={quantity}
            storeId={storeId}
            zipCode={zipCode}
            price={value}
            shippingModel={shippingModel}
            onZipCodeChange={onZipCodeChange}
          />
        )}
        maxWidth={320}
        placement="bottom"
      >
        <button type="button" className="u__default-link" onClick={handleOnClick}>
          {children}
        </button>
      </Tooltip>
    </div>
  );
};

DeliveryOptions.displayName = 'DeliveryOptions';

DeliveryOptions.propTypes = {
  itemId: PropTypes.string.isRequired,
  onZipCodeChange: PropTypes.func,
  children: PropTypes.node,
  visible: PropTypes.bool,
  quantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

DeliveryOptions.defaultProps = {
  onZipCodeChange: null,
  children: 'Delivery Options',
  quantity: 1,
  visible: false
};

DeliveryOptions.dataModel = extend(
  CheckAvailability,
  dataModel
);

export default DeliveryOptions;
